import { Injectable } from '@angular/core';
import {
  AbstractGraphqlRequest,
  GraphqlRequestType,
  PaginationResult,
} from '@ckmk/angular';
import {
  ServiceCategoriesResult,
  ServiceCategoryFetchAllPayload,
} from '@app/src/app/modules/service/types/types';
import { TypedDocumentNode } from '@apollo/client';
import { ServiceCategoryModel } from '@app/src/app/modules/service/classes/category/model/service.category.model';
import { gql } from 'apollo-angular';

@Injectable({
  providedIn: 'root',
})
export class ServiceCategoriesRequestQuery extends AbstractGraphqlRequest<
  ServiceCategoriesResult,
  { payload: ServiceCategoryFetchAllPayload }
> {
  protected override type: GraphqlRequestType = 'query';

  protected override getQuery(): TypedDocumentNode<any, any> {
    return gql`
      query findAllServiceCategories(
        $payload: ServiceCategoryRequestPayloadInput
      ) {
        findAllServiceCategories(payload: $payload) {
          pagination {
            hasNext
            hasPrevious
            limit
            page
            total
            totalPage
          }
          result {
            id
            cover {
              id
              name
              extension
              directory
              directories
              frontUrls
              mimetype
            }
            data {
              leftColor
              rightColor
            }
            slug
            title
            description
            shortDescription
            active
            createdAt
            updatedAt
            deletedAt
            createdBy
            updatedBy
          }
        }
      }
    `;
  }

  protected override onParseResult(data: any, payload?: any) {
    let { pagination, result } = data.findAllServiceCategories;

    if (pagination) {
      pagination = new PaginationResult(pagination);
    }

    result = result.map((grp: any) => new ServiceCategoryModel(grp));

    return { result, pagination };
  }
}
